import Code from "../../../../src/components/code";
import * as React from 'react';
export default {
  Code,
  React
};